import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    // Scroll to the top whenever the route changes
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location]);

  return null; // This component doesn't render anything
}
